export const IUBENDA_REDIRECTS = {
  PRIVACY_POLICY: 'https://www.iubenda.com/api/privacy-policy/43148992',
  PRIVACY_POLICY_COOKIES: 'https://www.iubenda.com/api/privacy-policy/43148992/cookie-policy',
  TERMS_OF_SERVICE: 'https://www.iubenda.com/api/termini-e-condizioni/43148992',
};

export const IUBENDA_INTERNAL_PAGES = {
  PRIVACY_POLICY: 'privacy-policy',
  PRIVACY_POLICY_COOKIES: 'cookie-policy',
  TERMS_OF_SERVICE: 'termini-e-condizioni',
};
